import type { StageConfig } from '@capture/shared';
import { StageDeepLinks } from './StageDeepLinks';

export function FormRecognitionPanel({ config, onChange: _onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  const recognitionConfigId = (config.config.recognitionConfigId as string) ?? 'none';
  return (
    <div className="stage-panel">
      <label>
        Recognition config
        <input value={recognitionConfigId} readOnly />
      </label>
      <StageDeepLinks stage="form-recognition" />
    </div>
  );
}
